import { Grid } from '@mui/material';
import { DateField, EmailField, SimpleShowLayout, TextField } from 'react-admin';
import { PhoneNumberArrayField } from 'src/lib';
import { AccountHolder } from 'src/models';

interface AccountHolderDetailsProps {
  record: AccountHolder;
}

export const AccountHolderDetails = ({ record }: AccountHolderDetailsProps) => {
  return (
    <Grid container direction='row'>
      <Grid item md={12}>
        <Grid container md={6}>
          <Grid item md={5}>
            <SimpleShowLayout>
              <TextField record={record} source='firstName' label='First Name' />
            </SimpleShowLayout>
          </Grid>
          <Grid item md={2}>
            <SimpleShowLayout>
              <TextField record={record} source='middleName' label='Middle Name' />
            </SimpleShowLayout>
          </Grid>
          <Grid item md={4}>
            <SimpleShowLayout>
              <TextField record={record} source='lastName' label='Last name' />
            </SimpleShowLayout>
          </Grid>
          <Grid item md={1}>
            <SimpleShowLayout>
              <TextField record={record} source='suffix' label='Suffix' />
            </SimpleShowLayout>
          </Grid>
        </Grid>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <EmailField record={record} source='email' label='Email' />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <PhoneNumberArrayField record={record.phones} />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <TextField record={record} source='maskedSsid' label='Ssid' />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <DateField record={record} source='dateOfBirth' label='Date of Birth' options={{ timeZone: 'UTC' }} />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <TextField record={record} source='maritalStatus.label' label='Marital Status' />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <TextField record={record} source='numberOfDependents' label='Number of Dependents' />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <TextField record={record} source='dateOfBirth' label='Birth Country' />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <TextField record={record} source='birthCountry.label' label='Citizenship Country' />
        </SimpleShowLayout>
      </Grid>
    </Grid>
  );
};
